import { createTheme } from '@mui/material/styles';

export const muiTheme = createTheme({
  zIndex: {
    modal: 10000
  },
  palette: {
    primary: {
      //main: '#e6e6e6' // mono grey
      main: '#666666' //darker default
      //main: '#1976d2' //this is default color
    },
    secondary: {
      main: '#f0f0f0' // lighter grey
      //main: '#666666' //darker default
    }
  },
  typography: {
    fontSize: 12
  },
  components: {
    MuiModal: {
      styleOverrides: {
        root: ({ theme }) => ({
          zIndex: theme.zIndex.modal
        })
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: ({ theme }) => ({
          zIndex: theme.zIndex.modal
        })
      }
    }
  }
})